import { css, keyframes } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
  shadows,
} from '../../styles/variables.style';

const fadeInLeft = keyframes`
  from { opacity: 0; transform: translateX(-50px); }
  to { opacity: 1; transform: translateX(0); }
`;

const fadeInRight = keyframes`
  from { opacity: 0; transform: translateX(50px); }
  to { opacity: 1; transform: translateX(0); }
`;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

export const pageWrapper = css`
  background-color: ${appColors.lightGray};
  min-height: 100vh;
  padding-bottom: 100px;
  overflow-x: hidden;
`;

export const heroContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  max-width: 1300px;
  margin: 0 auto;
  min-height: 60vh;
  gap: 40px;

  @media (min-width: ${breakpoints.lg.up}) {
    flex-direction: row;
    justify-content: space-between;
    padding: 80px 20px;
    gap: 80px;
  }
`;

export const heroLeft = css`
  flex: 1.2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  animation: ${fadeInLeft} 1.2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  width: 100%;

  @media (max-width: ${breakpoints.lg.down}) {
    align-items: center;
    text-align: center;
  }
`;

export const welcomeText = css`
  font-family: ${fontFamily.poppins};
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: ${appColors.gray800};
  margin-bottom: 20px;
  font-weight: 700;
`;

export const headline = css`
  font-family: ${fontFamily.poppins};
  font-size: 3rem;
  font-weight: 700;
  margin: 0 0 1.5rem;
  line-height: 1.2;
  color: ${appColors.gray800};

  span {
    color: ${appColors.orange};
  }

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 3.5rem;
    margin: 0 0 2rem;
  }
`;

export const line = css`
  font-family: ${fontFamily.poppins};
  font-size: 1rem;
  color: ${appColors.gray800};
  margin: 0 0 2.5rem;
  line-height: 1.8;
  max-width: 600px;
  opacity: 0.8;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 1.1rem;
  }
`;

export const heroRight = css`
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeInRight} 1.2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
`;

export const decorationCard1 = css`
  position: absolute;
  width: 280px;
  height: 320px;
  background: ${appColors.yellow};
  border-radius: 40px;
  transform: rotate(-15deg);
  z-index: -1;
  opacity: 0.8;
  box-shadow: ${shadows.neumorphic};

  @media (max-width: ${breakpoints.md.down}) {
    width: 200px;
    height: 240px;
  }
`;

export const decorationCard2 = css`
  position: absolute;
  width: 300px;
  height: 340px;
  background: transparent;
  border: 2px solid ${appColors.yellow};
  border-radius: 40px;
  transform: rotate(10deg);
  z-index: -2;
  opacity: 0.3;

  @media (max-width: ${breakpoints.md.down}) {
    width: 220px;
    height: 260px;
  }
`;

export const floatingShape = css`
  position: absolute;
  color: ${appColors.yellow};
  font-size: 24px;
  font-weight: 700;
  opacity: 0.6;
  z-index: 1;
  animation: ${float} 4s ease-in-out infinite;

  &.shape-plus {
    top: 10%;
    right: 10%;
    font-size: 40px;
    animation-delay: 0.5s;
  }

  &.shape-triangle {
    bottom: 10%;
    left: 10%;
    font-size: 30px;
    animation-delay: 1.2s;
  }
`;

export const heroImage = css`
  width: 100%;
  max-width: 450px;
  height: auto;
  position: relative;
  z-index: 2;
  filter: drop-shadow(20px 30px 50px rgba(0,0,0,0.15));
  border-radius: 20px;

  @media (max-width: ${breakpoints.lg.down}) {
    max-width: 300px;
  }
`;

export const sectionHeading = css`
  font-family: ${fontFamily.poppins};
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 50px;
  color: ${appColors.gray800};
`;

export const challengeGrid = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const loaderWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
`;
